export default ({ day, isSmall }) => {
  if (isSmall) {
    return day * 13
  }

  return 30 + day * 20
}
